import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import {
  IActiveCommunications,
  ICommunicationGroup,
} from '@/types/api/communications';

interface ICommunicationsContext {
  children: ReactNode;
}

interface ICommunicationContextData<T = ICommunicationGroup> {
  groupCommunications: T;
  setGroupCommunications: Dispatch<SetStateAction<T>>;
}

export const CommunicationsContext = createContext<ICommunicationContextData>(
  {} as ICommunicationContextData
);

export function CommunicationsProvider({ children }: ICommunicationsContext) {
  const [groupCommunications, setGroupCommunications] = useState(
    {} as ICommunicationGroup
  );

  return (
    <CommunicationsContext.Provider
      value={{
        groupCommunications,
        setGroupCommunications,
      }}
    >
      {children}
    </CommunicationsContext.Provider>
  );
}

export const useCommunications = () => {
  const context = useContext(CommunicationsContext);

  const updateCommunications = (communicationData: IActiveCommunications) => {
    context.setGroupCommunications(prevState => ({
      ...prevState,
      active_communications: prevState.active_communications?.map(
        communication => {
          if (communication.code === communicationData.code) {
            return communicationData;
          }
          return communication;
        }
      ),
    }));
  };

  if (!context) {
    throw Error('Must be inside a DefaultCompanyProvider');
  }

  return { ...context, updateCommunications };
};

export type { ICommunicationContextData };
